"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var styles = (0, _makeStyles.default)(function (theme) {
  return {
    addition: {
      marginTop: theme.spacing(0.5)
    },
    input: {
      flex: "0 0 100%",
      "& .MuiTextField-root": {
        width: "100%"
      },
      "& input:-ms-input-placeholder, & input:-ms-reveal": {
        color: "inherit",
        opacity: 1
      }
    },
    file: {
      "& input": {
        paddingTop: theme === null || theme === void 0 ? void 0 : theme.spacing(6)
      }
    },
    fileSmall: {
      "& input": {
        paddingBottom: theme.spacing(2.5),
        paddingTop: theme === null || theme === void 0 ? void 0 : theme.spacing(5)
      }
    }
  };
});
var _default = styles;
exports.default = _default;